module.exports = __webpack_public_path__ + "static/img/tagheuer_logo_menu.9668261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tagheuer_logo_menu.png
// module id = yTJF
// module chunks = 1